export function formatText1(text) {
  if (!text) return "";

  // Convert special characters to HTML-safe format
  let formatted = text
    .replace(/\n/g, "<br/>") // Convert line breaks to <br/>
    .replace(/  /g, "&nbsp;&nbsp;"); // Preserve double spaces

  return formatted;
}

export function convertTermsToHtml(raw) {
  // 1) Replace *text* with <strong>text</strong>
  //    - ([^*\n]+?) ensures we don't match across newlines or consume extra asterisks.
  //    - global flag to replace all occurrences.
  const bolded = raw.replace(/\*([^*\n]+?)\*/g, "<strong>$1</strong>");

  // 2) Replace line breaks with <br/>
  const html = bolded.replace(/\r?\n/g, "<br/>");

  // Optional: collapse multiple consecutive <br/> into two (preserve paragraph spacing)
  // html = html.replace(/(<br\/>){3,}/g, '<br/><br/>');

  return html;
}
